// components/ChangeModal.js
import React from 'react';
import '../styles/Modal.css';

function ChangeModal({ title, children, isOpen, onClose, modalClass = '' }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className={`change-modal-content ${modalClass}`}>
        <h3>{title}</h3>
        {children}
        <button className="close-btn" onClick={onClose}>Kapat</button>
      </div>
    </div>
  );
}


export default ChangeModal;
